import styled, { css } from 'styled-components';

export const Area = styled.textarea`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 8px;
    outline: none;
    resize: none;

    font-size: 16px;
    font-weight: 400;
    color: ${theme?.colour?.secondary ?? "#04333b"};

    @media only screen and (min-width: 768px) {
      scrollbar-width: thin;
      scrollbar-color: #E3E3E3 transparent;
    }
    ::placeholder {
      color: #9EACB0;
    }

    &:disabled {
      color: #E3E3E3;
      background-color: unset;
    }

    /* width */
    ::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #A5E5C4; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #A5E5C4; 
    }
  `}
`;
